// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VHgUP","title":"styles_title__Ns2Ns","text":"styles_text__61QtB","slide-in-bottom":"styles_slide-in-bottom__CavzN"};